export default value => {
  return value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
}



// WEBPACK FOOTER //
// ./src/components/validators/EmailValidator.js